
<template>
	<div id="body-container">
		<navbar  :class="{active:'bg-dark'}"/>
		<div class="SessionPopup">
			<SessionPopup />
		</div>
		<div class="overlay" :class="{ active: 'isOverlayActive' }" v-if="isSessionPopupVisible == true"></div> <!-- Overlay here -->
		<div class="flex bg-dark" @click="closeApps()">
			<div :class="{ 'w-40': isToggling, 'w-10': !isToggling }">
				<div class="lg:flex mainlogo">
						<span class="text-lg font-bold ">
							<img src="@/assets/crystaSureLogo.svg" alt=""  v-if="isSidebarToggle" class="crystaSureLogo"/>
							<img src="@/assets/crystaSureShield.svg" alt="" v-else  class="crystaSureShield"/>
						</span>
					</div>
				<div class="fixed h-full sidebar bg-white sideheight sidenav z-50" :class="{ 'w-40': isToggling, 'w-10': !isToggling ,active:'bg-dark-blue'}">
					<ul>
						<li @click="navigate('master','master')"
						 class="cursor-pointer text-black hover:bg-primary svg-icon pl-2.5 pr-2.5" 
						:class="selectedOptionName === 'master' ? 'bg-primary text-white font-normal a svg-icon123' : 'text-black font-normal'"
						 @mouseenter="sidebar.master = true"
						 @mouseleave="sidebar.master = false">
						 <div>
								<a class="flex controlalign navchild items-center hover:text-white py-1.5">
									<div class="py-0.5">
									<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M4.9254 2.60073L1.0093 4.29313L1.00445 4.86803L1.00122 5.44455H1.54867H2.0945L2.10419 5.51722C2.1268 5.68194 2.26083 5.8628 2.41909 5.94032L2.51114 5.98553H8.88995H15.2688L15.3447 5.95001C15.5126 5.87249 15.6563 5.6884 15.6757 5.52368L15.6854 5.44455H16.2167H16.7464L16.7431 4.86965L16.7383 4.29475L12.8077 2.60073C10.6469 1.66894 8.86895 0.906713 8.85927 0.908328C8.84958 0.908328 7.07966 1.67055 4.9254 2.60073Z" fill="black"/>
										<path d="M3.08489 9.94937V13.3374L2.78291 13.3455C2.49384 13.3519 2.47446 13.3552 2.3808 13.3972C2.2613 13.4504 2.13211 13.5764 2.08043 13.6894C2.04652 13.7637 2.04329 13.796 2.03844 14.1287L2.03198 14.4888H8.88072H15.7295V14.1416C15.7295 13.8348 15.7262 13.7863 15.6972 13.7088C15.6503 13.5829 15.5292 13.4553 15.4033 13.3988C15.3064 13.3552 15.2886 13.3519 14.9995 13.3455L14.6959 13.3374V9.94937V6.55972H13.6382H12.5804V9.95098V13.3422H12.0637H11.5469V9.95098V6.55972H10.4891H9.4314V9.95098V13.3422H8.91463H8.39787V9.95098V6.55972H7.34012H6.28237V9.95098V13.3422H5.7656H5.24884V9.95098V6.55972H4.16686H3.08489V9.94937Z" fill="black"/>
										<path d="M1.39403 15.0851C1.239 15.1383 1.12112 15.2417 1.04683 15.3935C1.00969 15.4645 1.00969 15.4791 1.00484 16.1073L1 16.75H8.87419H16.75L16.7435 16.1234L16.7387 15.4985L16.6935 15.4C16.6386 15.2805 16.511 15.1513 16.3996 15.0996L16.3188 15.0624L8.89842 15.0592C1.79129 15.056 1.47478 15.056 1.39403 15.0851Z" fill="black"/>
									</svg>
									</div>
									<div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'master' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Organization</div>
								</a>
						 </div>
							<div v-if="sidebar.master && !isSidebarToggle" class="absolute z-50 rounded tooltipwidth transform-y-top left-11 whitespace-nowrap">
								<div class="px-2 text-white bg-tooltip">Organization</div>
							</div>
						</li>
						<li @click="navigate('courses','courses')" 
						class="cursor-pointer text-black hover:bg-primary svg-icon pl-2.5 pr-2.5" 
						:class="selectedOptionName === 'courses' ? 'bg-primary text-white font-bold a svg-icon123' : 'text-black font-normal'"
						  @mouseenter="sidebar.courses = true"
						   @mouseleave="sidebar.courses = false">
							<div>
								<a class="flex navchild items-center hover:text-white py-1.5">
									<div class="py-0.5">
									<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M6.63077 3.29538C4.16308 3.64 2.31385 3.91077 2.23385 3.94154C1.90462 4.06769 1.61231 4.44 1.52 4.85846C1.45846 5.12308 1.46769 5.78154 1.53231 6.10769C1.59077 6.38154 1.76923 6.79385 1.90154 6.95385L1.97846 7.04615L1.65231 7.14461C1.29846 7.25231 1.23692 7.29231 1.24 7.41538C1.24 7.52923 1.34769 7.63077 1.55077 7.70769C1.79385 7.80308 1.96615 7.99077 2.04615 8.25538C2.12308 8.49846 2.15692 8.88 2.12615 9.15692L2.10154 9.35385L1.69846 9.48615C1.21846 9.64 1 9.76308 1 9.87692C1 9.95385 1.01231 9.96 1.31385 10.0308L1.39692 10.0523L1.28 10.2246C1.21538 10.3231 1.12923 10.4831 1.08923 10.5846C1.02154 10.7538 1.01846 10.8123 1.01846 11.3385C1.01846 11.8246 1.02769 11.9415 1.08615 12.1477C1.2 12.5631 1.40308 12.8923 1.64308 13.0462C1.74769 13.1138 7.49846 15 7.6 15C7.67385 15 16.1754 12.9354 16.24 12.9046C16.4215 12.8062 16.1538 12.6215 15.5262 12.4154L15.1692 12.2985L15.1477 12.0708C15.1231 11.7846 15.1692 11.3508 15.2431 11.1508C15.3385 10.9015 15.4308 10.8062 15.7138 10.6677C16.0031 10.5262 16.0769 10.44 16.0277 10.2985C16.0062 10.2338 15.9631 10.2031 15.8246 10.1569L15.6492 10.1015L15.7877 9.96308C16.0646 9.68308 16.2431 9.17538 16.28 8.55385C16.3108 8.03692 16.2215 7.60923 16.0277 7.32308C15.9846 7.25846 15.9538 7.20308 15.96 7.2C15.9662 7.19692 16.0738 7.16923 16.2 7.14154C16.3262 7.11385 16.5046 7.06769 16.5938 7.04308C16.7446 7 16.7569 6.99077 16.7477 6.91385C16.7354 6.80308 16.4923 6.67385 16.0092 6.51692L15.6492 6.4L15.6277 6.17231C15.5846 5.70154 15.6831 5.21231 15.8646 4.99077C15.9292 4.91385 16.04 4.83692 16.1815 4.77231C16.3015 4.71692 16.4246 4.64 16.4585 4.60615C16.5262 4.52923 16.5323 4.39692 16.4708 4.33538C16.4062 4.27077 11.1446 2.69231 11.0062 2.69538C10.9446 2.69846 8.97538 2.96615 6.63077 3.29538ZM5.33231 5.47692C6.86462 5.97846 8.12308 6.39077 8.12615 6.39384C8.14154 6.40615 8.07077 8.21538 8.05846 8.22769C8.05231 8.23692 6.79077 7.88923 5.25231 7.46154C3.00308 6.83385 2.44 6.66461 2.35385 6.6C2.12615 6.42461 2.00308 6.03384 2 5.46154C2 5.04923 2.05538 4.84615 2.21538 4.67692C2.29538 4.59077 2.33846 4.56923 2.43077 4.56923C2.49846 4.56923 3.68923 4.94154 5.33231 5.47692ZM15.3785 5.20615C15.2892 5.48615 15.2554 5.96923 15.2985 6.31385L15.3262 6.53538L14.6185 6.70769C14.2277 6.80308 12.6708 7.18769 11.16 7.56615L8.41231 8.25538L8.43385 7.46461C8.44615 7.03077 8.46462 6.61538 8.47385 6.53846L8.49231 6.40308L11.9538 5.68923C13.8585 5.29538 15.4246 4.97231 15.4338 4.97231C15.4462 4.96923 15.4215 5.07692 15.3785 5.20615ZM15.52 7.6C15.7138 7.76308 15.8062 8.22769 15.7446 8.72615C15.6892 9.17538 15.5415 9.48923 15.3385 9.6C15.2492 9.64923 9.71077 11.2 9.69538 11.1815C9.68 11.1662 9.61539 9.35692 9.62769 9.34461C9.63385 9.34154 10.8831 8.92923 12.4031 8.43077C14.1138 7.87385 15.2185 7.52615 15.2985 7.52615C15.3938 7.52308 15.4492 7.54461 15.52 7.6ZM5.83077 8.64615C7.71692 9.03385 9.26769 9.35385 9.27385 9.36C9.29231 9.37231 9.34461 11.1569 9.32615 11.1754C9.31692 11.1846 7.76308 10.8092 5.87692 10.3415L2.44308 9.48615L2.46462 9.09846C2.48615 8.67385 2.45231 8.36923 2.35385 8.08615C2.29846 7.92615 2.29846 7.91692 2.34769 7.92923C2.37846 7.93846 3.94769 8.26154 5.83077 8.64615ZM4.86154 11.3815L7.63077 12.2862L7.64 12.4338C7.65231 12.6462 7.6 14.1046 7.57846 14.1231C7.56923 14.1354 6.29538 13.7877 4.75077 13.3569L1.93846 12.5692L1.80923 12.4277C1.62154 12.2277 1.55077 11.9815 1.53231 11.4923C1.50462 10.8092 1.65231 10.48 1.98462 10.48C2.04308 10.4769 3.33846 10.8862 4.86154 11.3815ZM14.9538 10.9292C14.9415 10.96 14.9046 11.0923 14.8708 11.2277C14.8185 11.4308 14.8123 11.5446 14.8185 11.9538L14.8308 12.4369L11.3938 13.2923C9.50154 13.7662 7.95077 14.1446 7.94154 14.1354C7.92308 14.1138 7.98769 12.3415 8.00923 12.32C8.02154 12.3077 8.34769 12.2338 8.73231 12.1569C9.24615 12.0523 9.47077 12.0185 9.56615 12.0308C9.67077 12.0492 9.78154 12.0246 10.1108 11.92C10.3877 11.8338 11.2462 11.64 12.7077 11.3385C13.9108 11.0892 14.9108 10.8831 14.9354 10.88C14.9631 10.8769 14.9692 10.8954 14.9538 10.9292Z" fill="black"/>
									</svg>
									</div>
									<div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'courses' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Courses</div>
								</a>
							</div>
							<div v-if="sidebar.courses && !isSidebarToggle" class="absolute z-50  rounded tooltipwidth  pointer-events-none transform-y-top left-11 whitespace-nowrap">
								<div class="px-2 text-white bg-tooltip">Courses</div>
							</div>
						</li>
					</ul>
					<ul class="bottomUl">
						<li class="relative">
							<hr class="mb-4" />		
				<img src="@/assets/leftArrowIcon.svg" class=" icon   arrowIcon leftarrow absolute cursor-pointer" alt="" @click="toggleSideMenuBar()" v-if="isSidebarToggle" />
							<img src="@/assets/rightArrowIcon.svg" class="arrowiconRight  icon  rightarrow absolute cursor-pointer" alt="" @click="toggleSideMenuBar()" v-else />		
						</li>
				<li class="setting">
					<a @click="triggerNavToAdminSettings()" class="flex navchild items-center py-1 pl-2.5 ">
						<div class="mr-2 h-5">
							<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M16.463 7.58168L14.4393 7.2509C14.3209 6.84478 14.1589 6.45442 13.9562 6.08495L15.1375 4.40127C15.2331 4.26533 15.2166 4.08008 15.0992 3.96228L13.7675 2.63129C13.6487 2.51282 13.4617 2.49741 13.3254 2.59568L11.6671 3.78765C11.2942 3.58151 10.9004 3.41783 10.4919 3.29901L10.1389 1.28352C10.1101 1.11985 9.96801 1 9.80159 1H7.91827C7.75049 1 7.60736 1.12156 7.5803 1.28729L7.25295 3.29182C6.84205 3.40996 6.44758 3.57192 6.07605 3.77532L4.42216 2.59397C4.28553 2.49638 4.0996 2.51213 3.98078 2.63027L2.64978 3.96126C2.53233 4.07871 2.5159 4.26362 2.61143 4.39956L3.77532 6.06475C3.56816 6.4397 3.40311 6.83657 3.28292 7.24953L1.28626 7.58202C1.12122 7.60941 1 7.75254 1 7.91964V9.80296C1 9.96904 1.11916 10.1111 1.2825 10.1402L3.27915 10.4943C3.39866 10.9062 3.56371 11.3031 3.77156 11.6791L2.59329 13.3272C2.49604 13.4631 2.51145 13.6497 2.62958 13.7685L3.96091 15.1009C4.07837 15.2183 4.26362 15.2348 4.39956 15.1392L6.06715 13.9713C6.44141 14.177 6.83691 14.3404 7.24679 14.4589L7.58099 16.4658C7.60804 16.6305 7.75083 16.7514 7.91827 16.7514H9.80159C9.96766 16.7514 10.1098 16.6322 10.1385 16.4689L10.4964 14.452C10.9069 14.3311 11.3004 14.1668 11.6709 13.9606L13.3504 15.1389C13.4867 15.2351 13.6716 15.2183 13.7894 15.1009L15.1208 13.7685C15.2392 13.6497 15.2546 13.4624 15.1564 13.3261L13.9586 11.663C14.1616 11.2932 14.3229 10.9021 14.4404 10.496L16.4668 10.1402C16.6308 10.1115 16.75 9.96904 16.75 9.80296V7.91964C16.7503 7.75186 16.6288 7.60873 16.463 7.58168ZM8.875 11.2726C7.5512 11.2726 6.47805 10.1995 6.47805 8.87568C6.47805 7.55188 7.5512 6.47874 8.875 6.47874C10.1988 6.47874 11.2719 7.55188 11.2719 8.87568C11.2719 10.1995 10.1988 11.2726 8.875 11.2726Z" fill="black"/>
							</svg>
						</div>
				<div class="item-name leading-5 text-sm text-black" v-if="isSidebarToggle">Settings</div>
							</a>
						</li>
					</ul>
				</div>

				<div class="fixed z-50 bg-white w-40 px-2 py-1 flex flex-col justify-center" v-if="appsVisible">
				<div class="flex flex-row items-center cursor-pointer">
					<!-- <div class="flex flex-col mr-1 w-2/4  cursor-pointer items-center" @click="triggerNav()">
						<img src="@/assets/monitoring.svg" alt="" class="icn h-6 w-6 ml-2" />
						<div class="nav-item-label-container">
							<div class="nav-item-label">Monitor</div>
						</div>
					</div> -->
					<div class="flex flex-row items-center cursor-pointer">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g clip-path="url(#clip0_4516_14738)">
							<path d="M0 0C7.92 0 15.84 0 24 0C24 7.92 24 15.84 24 24C16.08 24 8.16 24 0 24C0 16.08 0 8.16 0 0Z" fill="#FF9A00"/>
							<path d="M19.6399 17.0902V8.18107C19.6399 7.67475 19.4388 7.18916 19.0808 6.83114C18.7227 6.47311 18.2371 6.27198 17.7308 6.27198H17.0945C17.0944 5.97653 17.0258 5.68513 16.894 5.42071C16.7622 5.15629 16.5708 4.92607 16.3349 4.74817C16.099 4.57027 15.8251 4.44954 15.5346 4.3955C15.2441 4.34145 14.9451 4.35556 14.661 4.43671L12.7519 4.98271C12.4741 5.06217 12.2181 5.20408 12.0036 5.39762C11.789 5.20408 11.533 5.06217 11.2552 4.98271L9.3461 4.43671C9.06201 4.35556 8.76297 4.34145 8.4725 4.3955C8.18204 4.44954 7.90809 4.57027 7.6722 4.74817C7.43632 4.92607 7.24494 5.15629 7.11314 5.42071C6.98134 5.68513 6.9127 5.97653 6.91264 6.27198H6.27628C5.76996 6.27198 5.28437 6.47311 4.92635 6.83114C4.56832 7.18916 4.36719 7.67475 4.36719 8.18107V17.0902H11.3672V18.3629H8.82173V19.6356H15.1854V18.3629H12.6399V17.0902H19.6399ZM12.6399 6.81798C12.64 6.67977 12.685 6.54534 12.7683 6.43501C12.8515 6.32467 12.9684 6.24444 13.1013 6.20643L15.0104 5.66107C15.0673 5.6446 15.1261 5.63604 15.1854 5.63562C15.3541 5.63562 15.516 5.70266 15.6353 5.822C15.7547 5.94134 15.8217 6.1032 15.8217 6.27198V10.2467L12.6399 11.1554V6.81798ZM8.18537 6.27198C8.18551 6.17354 8.20849 6.07648 8.25249 5.98843C8.29649 5.90038 8.36032 5.82373 8.43896 5.76453C8.51759 5.70532 8.6089 5.66516 8.70568 5.64721C8.80246 5.62925 8.90209 5.634 8.99673 5.66107L10.9058 6.20643C11.0387 6.24444 11.1556 6.32467 11.2388 6.43501C11.3221 6.54534 11.3671 6.67977 11.3672 6.81798V11.1554L8.18537 10.2467V6.27198ZM5.63991 8.18107C5.63991 8.0123 5.70696 7.85043 5.8263 7.73109C5.94564 7.61175 6.1075 7.54471 6.27628 7.54471H6.91264V11.2063L12.0036 12.6611L17.0945 11.2063V7.54471H17.7308C17.8996 7.54471 18.0615 7.61175 18.1808 7.73109C18.3001 7.85043 18.3672 8.0123 18.3672 8.18107V15.8174H5.63991V8.18107Z" fill="white"/>
							</g>
							<defs>
							<clipPath id="clip0_4516_14738">
							<rect width="24" height="24" rx="4" fill="white"/>
							</clipPath>
							</defs>
						</svg>
						<div class="nav-item-label-container ml-2">
							<div class="text-sm font-semibold">Training</div>
							<div class="active-border"></div>
						</div>
					</div>
				</div>
			</div>
			
			</div>
			<div class="mt-12 flex-1 w-full h-screen overflow-y-scroll">
				<div :class="{ toggledstate: isToggling }">
					
					<div class="page">
						<slot />
					</div>
					<Footer  class="bg-dark-blue"/>	
				</div>
			</div>
		</div>
</div>
</template>
<style  scoped>
.mainlogo{
	position:fixed;
	margin-left:9px;
	z-index:52;
}
.sideheight{
	height: 100%;
    z-index: 51;
}
.sidebar{
	padding-top:85px;
	border-right:1px solid var(--color-lightgrey);
}
.bottomUl{
    height: 51px;
}
.setting{
    height: 35px;
    margin-top: 5px;
}
.min-h-30{
	height: 50px;
}
.apps{
	background-color: #f9f9fb;
	padding-left:7px;
}
.bg-dark.active {
  /* background-color:rgba(8, 8, 8, 0.5); */
  opacity:0.7;
  z-index:999;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7); /* Black with opacity */
  z-index: 9999;
  display: none; /* Initially hidden */
}

.overlay.active {
  display: block; /* Show the overlay when active */
}
.bg-dark-blue.active{
	/* background-color:rgba(0, 0, 0, 0.5); */
	opacity: 0.7;
}
.w-3{
	width:15px
}
.page{
	margin-bottom: 150px;
}
.controlalign{
	padding-top: 6px;
	padding-bottom: 6px;
}
.arrowIcon{
	height:22px;
	width:22px;
	margin-left:156px;
}
.arrowiconRight{
	height:22px;
	width:22px;
	margin-left:29px;
}
.shadowapps{
	--tw-shadow:5px 5px 5px 0px rgba(0, 0, 0, 0.25);
	box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.leftarrow,.rightarrow  {
	/* height: 1.25rem;
	width: 1.25rem; */
	color: red;
	margin-top: -27px;
}

.sidenav {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.navbar{
	min-height: 40px;
	height: 48px;
}

.SessionPopup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
  z-index: 99999; /* Ensure it's above other content */
}
.a:hover{
	color:white;
	font-weight: bold;
}

.icon:hover {
transition: none !important;
}
.svg-icon:hover {
    color:white;
}
.svg-icon123 div a svg path,
.svg-icon123 div a svg rect,
.svg-icon:hover path,
.svg-Image:hover svg path,
.svg-Image:hover svg rect,
.svg-icon:hover rect
 {
    fill: white;
}
.svg-icon:hover path {
    width:20px;
	height:20px;
}
.tooltipwidth {
	width: auto;
}
.bg-tooltip{
	background-color: #1976d2;
}
.transform-y-top{
	transform: translateY(-26px);
}
</style>
 <script lang="ts">
import navbar from '@/components/navbar.vue';
import { defineComponent } from 'vue';
import Footer from '@/components/footer.vue'
import { emitter } from '../main';
import { mapGetters } from 'vuex';
import SessionPopup from '@/components/sessionpopup.vue';
export default defineComponent({
	components: {
		navbar,
		Footer,
		SessionPopup
	},
	data() {
		return {
			isToggling: true,
			isSidebarToggle:true,
			appsVisible:false,
			organisation:false,
			courses:false,
			passingRouteName:'',
			selectedOptionName:'',
			sidebar: { master: false, courses: false },
			resizeTimeout:0,
			menus: [
				{
					optionName: 'master',
					optionRoute: 'master',
					defaultoptionImage: require('@/assets/organisationDefault.svg'),
					colouredoptionImage: require('@/assets/organisationColoured.svg'),
					displayOptionName: 'Organization',
				},
				{
					optionName: 'courses',
					defaultoptionImage: require('@/assets/coursesDefault.svg'),
					colouredoptionImage: require('@/assets/coursesColoured.svg'),
					optionRoute: 'courses',
					displayOptionName: 'Courses',
				}
			],
			isSessionPopupVisible:false
		};
	},
	computed:{
		...mapGetters({ toggleState:'toggle' })
	},
	mounted() {
		window.addEventListener('resize', this.debouncedHandleResize);
		this.isToggling = this.toggleState;
		this.isSidebarToggle=this.toggleState;
		emitter.on('toggle-sidebar', (isToggle: any) => {
			this.isToggling = isToggle;
		});
		emitter.on('apps-sidemenubar', (isToggle: any) => {
			this.appsVisible = isToggle;
		});
		emitter.off('isvisible');
		emitter.on('isvisible',(data:any)=>{
		this.isSessionPopupVisible = data;			

		})
	},
	 beforeUnmount() {
        window.removeEventListener('resize', this.debouncedHandleResize);
    },
	async created(){
		if(this.$route.path.includes('master')){
            this.passingRouteName = 'master'
        }else if(this.$route.path.includes('courses')||this.$route.path.includes('course')){
            this.passingRouteName = 'courses'
        }
		this.selectedOptionName = this.passingRouteName;
		emitter.off('isvisible');
		emitter.on('isvisible',(data:any)=>{
		this.isSessionPopupVisible = data;			

		})
		
	},
	methods: {
		closeApps(){
			this.appsVisible=false;
		emitter.emit('apps', this.appsVisible);
		},
		triggerNavToAdminSettings() {
			window.location.href = `${process.env.VUE_APP_AUTH_WEBAPP_URL}/session?returnTo=${process.env.VUE_APP_ADMIN_WEBAPP_URL}`;
		},
		triggerNav() {
			window.location.href = `${process.env.VUE_APP_AUTH_WEBAPP_URL}/session?returnTo=${process.env.VUE_APP_MONITOR_WEBAPP_URL}`;
		},
		toggleSideMenuBar() {
			this.isToggling = !this.isToggling;
			this.isSidebarToggle=!this.isSidebarToggle
			emitter.emit('toggle-sidebar', this.isSidebarToggle);
		},
		navigate(name:any, routerOption:any) {
			this.$store.dispatch('selectedRoute', name);
			this.$store.dispatch('selectedToggle',this.isToggling);
			this.$router.push({ name: routerOption });
		},
		 debouncedHandleResize() {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(this.handleResize, 100); // Adjust debounce time as needed
        },
        handleResize() {
            // if(window.innerWidth<720)
            // {
			// 	this.$store.dispatch('selectedToggle', false);
			// 	this.isSidebarToggle = false;
			// 	emitter.emit('toggle-sidebar', this.isSidebarToggle);
            //     // console.log("hii checking reponsive or not");
            // }
			// else{
			// 	this.$store.dispatch('selectedToggle', true);
			// 	this.isSidebarToggle = true;
			// 	emitter.emit('toggle-sidebar', this.isSidebarToggle);
			// 	// console.log("big screen");
			// }

			if(window.innerWidth<1164)
            {
                this.$store.dispatch('selectedToggle', false);
                this.isSidebarToggle = false;
                emitter.emit('toggle-sidebar', this.isSidebarToggle);
            }
            else if(this.isSidebarToggle == false){
                this.$store.dispatch('selectedToggle', true);
                this.isSidebarToggle = true;
                emitter.emit('toggle-sidebar', this.isSidebarToggle);
            }
        },
	}
});
</script>